module.exports = __webpack_public_path__ + "front/img/p12.d31563c6.png";